'use client';

import { useJump } from '@/components/MagicJump';
import { getSpmPositionCode, useGlobalSpmTerminal } from '@/components/Layout/spmTerminal';
import { useRouteCnName } from '@/hooks/useRouteMetadata';
import { useTranslations } from '@/i18n/use-translations';
import { useStore } from '@/providers/app-store-provider';
import { useSpmDomAttr, withSpmCnt } from '@/reporting/spm';
import { EPlatform } from '@/utils/enums/platform-enum';
import { sensorsTrack } from '@/utils/sensors';

const SubscribeCoupon = ({ bottomSubscribeBoxTxt = '' }: { bottomSubscribeBoxTxt?: string }) => {
  const token = useStore((state) => state.token);
  const userInfo = useStore((state) => state.userInfo);
  const setLoginRegisterShow = useStore((state) => state.setShowLoginRegisterDialog);
  const t = useTranslations('layout.footer');
  const toJumpTarget = useJump();
  const pageName = useRouteCnName();
  const spmPage = useGlobalSpmTerminal(EPlatform.WAP);
  const submitSubscriptionSpmCnt = getSpmPositionCode(
    spmPage,
    'footer_subscribe',
    'submit_subscription',
  );
  const submitSubscriptionDomSpm = useSpmDomAttr(submitSubscriptionSpmCnt);

  const handleOnTabSubscribe = () => {
    // 整个入口由父层处理点击，按钮冒泡只上报一次；App 内嵌沿用 global_app。
    const properties = { page_name: pageName, btn_name: t('subscribe.subscribeButton') };
    sensorsTrack(
      'EDMModule_Click',
      submitSubscriptionSpmCnt ? withSpmCnt(properties, submitSubscriptionSpmCnt) : properties,
    );
    if (token) {
      toJumpTarget({
        Jump_target: `/account/my-account?email=${userInfo?.email}`,
        jump_type: 4,
      });
      return;
    }

    setLoginRegisterShow({
      show: true,
      eventType: 'bottom_register',
      situation: '底部导航领券',
    });
  };

  return (
    <section className="flex w-full flex-col items-center gap-[16px] py-[16px]">
      <p
        className="w-full break-words text-center font-br text-[14px] font-normal leading-[17px] text-primary-white"
        dangerouslySetInnerHTML={{ __html: bottomSubscribeBoxTxt }}
      />
      <div
        className="relative flex h-[50px] w-full items-center rounded-[6px] border border-solid border-[#d1d9e0] bg-primary-white px-[12px] py-[6px]"
        onClick={handleOnTabSubscribe}
        {...submitSubscriptionDomSpm}
      >
        <span className="pr-[104px] font-br text-[14px] font-normal leading-[17px] text-[#6c6c6c]">
          {t('subscribe.emailPlaceholder')}
        </span>
        <button
          type="button"
          className="absolute right-[5px] top-1/2 flex h-[38px] w-[96px] -translate-y-1/2 items-center justify-center rounded-[4px] bg-primary-purple px-[16px] py-[10px] font-br text-[12px] font-normal leading-[14px] text-primary-white"
        >
          {t('subscribe.subscribeButton')}
        </button>
      </div>
    </section>
  );
};

export default SubscribeCoupon;
